/**
 * Bounded undo/redo stack for the FlowEditor.
 *
 * Snapshots are opaque — the caller decides what shape "current state" has
 * and hands the same shape back on apply. Keeping the module ignorant of
 * that shape lets it stay a pure-function unit and lets tests skip React.
 *
 * A push captures the state *before* a mutation, so undo restores that
 * pre-mutation state. Push also clears the future stack: once the user
 * makes a fresh edit, the redo path is no longer valid.
 */
export const HISTORY_CAP = 50;
export function empty() {
    return { past: [], future: [] };
}
export function canUndo(history) {
    return history.past.length > 0;
}
export function canRedo(history) {
    return history.future.length > 0;
}
/** Push `previous` (the state before a mutation) onto the past stack. */
export function push(history, previous) {
    const past = [...history.past, previous];
    while (past.length > HISTORY_CAP)
        past.shift();
    return { past, future: [] };
}
/** Undo returns the snapshot to restore, or null if the past is empty. */
export function undo(history, current) {
    if (history.past.length === 0)
        return null;
    const past = history.past.slice(0, -1);
    const snapshot = history.past[history.past.length - 1];
    const future = [current, ...history.future];
    return { history: { past, future }, snapshot };
}
/** Redo returns the snapshot to restore, or null if the future is empty. */
export function redo(history, current) {
    if (history.future.length === 0)
        return null;
    const [snapshot, ...future] = history.future;
    const past = [...history.past, current];
    return { history: { past, future }, snapshot };
}
//# sourceMappingURL=history.js.map